import { reducer, union } from "ts-action";
import { on } from "ts-action-immer";
import { editRowPLACEHOLDER } from "../../../requests/tableRowActions/placeholderData";
import {
  addNewDAndPTemplateItem,
  deleteDAndPTemplateItem,
  isFetchingEditRow,
  isFetchingModel,
  isFetchingSqlQuery,
  receiveEditRow,
  receiveSqlQuery,
  receiveTemplateBuilder,
  receiveTemplateBuilderModels,
  revalidateTemplateBuilder,
  updateBothTemplateItems,
  updateDataTemplate,
  updateDataTemplateItem,
  updateDataTemplateItems,
  updateDetailTemplates,
  updateDetailTemplatesOrder,
  updatePresentationTemplate,
  updatePresentationTemplateItem,
  updatePresentationTemplateItems,
  updateTemplateBuilder,
  updateTemplateBuilderEditRow,
  setStateChanged,
} from "../actionCreators";
import { ModelReducerState } from "../types";
import dataReducer, { dataReducerInitialState } from "./dataReducer";
import editRowReducer from "./editRowReducer";
import { invalidatedDatasetsForTemplateIdInitialState } from "./invalidatedDatasetsForTemplateIdReducer";
import sqlQueryReducer from "./sqlQueryReducer";

const initialState: ModelReducerState = {
  id: -1,
  model: dataReducerInitialState,
  stateChanged: false,
  editRow: {
    data: editRowPLACEHOLDER,
    isFetching: false,
  },
  sqlQuery: {
    data: null,
    isFetching: false,
  },
  invalidatedDatasets: invalidatedDatasetsForTemplateIdInitialState,
};

const modelReducer = reducer(
  initialState,
  on(...union(receiveTemplateBuilder, isFetchingModel), (state, action) => {
    state.id = action.payload.templateBuilderId;
    state.model = dataReducer(state.model, action);
    state.stateChanged = false;
  }),
  on(
    ...union(
      updateTemplateBuilder,
      updateDataTemplate,
      updatePresentationTemplate,
      updateDataTemplateItems,
      updatePresentationTemplateItems,
      updateDataTemplateItem,
      updatePresentationTemplateItem,
      updateBothTemplateItems,
      updateDetailTemplates,
      updateDetailTemplatesOrder,
      addNewDAndPTemplateItem,
      deleteDAndPTemplateItem
    ),
    (state, action) => {
      state.model = dataReducer(state.model, action);
      state.stateChanged = true;
    }
  ),
  on(...union(setStateChanged), (state, { payload: { newState } }) => {
    state.stateChanged = newState;
  }),
  on(
    ...union(revalidateTemplateBuilder, receiveTemplateBuilderModels),
    (state, action) => {
      state.model = dataReducer(state.model, action);
    }
  ),
  on(...union(receiveEditRow, isFetchingEditRow), (state, action) => {
    state.editRow = editRowReducer(state.editRow, action);
    state.stateChanged = false;
  }),
  on(updateTemplateBuilderEditRow, (state, action) => {
    state.editRow = editRowReducer(state.editRow, action);
    state.stateChanged = true;
  }),
  on(...union(receiveSqlQuery, isFetchingSqlQuery), (state, action) => {
    state.sqlQuery = sqlQueryReducer(state.sqlQuery, action);
    state.stateChanged = false;
  })
);

export default modelReducer;
